/**
 * Telefon numarası — tek biçim, tek kaynak.
 *
 * Sistem yalnızca Türkiye numaralarıyla çalışır. Kullanıcıya hangi biçimde
 * yazacağı DAYATILMAZ: "0532…", "532…", "+90 532…", "90532…", boşluklu ve
 * tireli yazımların hepsi aynı numaradır. Üç iş vardır ve üçü de buradadır:
 *
 *   · telefonNormalize — SAKLAMA biçimi. Ülke kodu ve baştaki sıfır atılmış
 *     10 hane: `5321110001`. Veli girişinin anahtarıdır (UNIQUE (okul_id,
 *     telefon)); API'nin yazan ve okuyan tüm uçları bunu kullanır.
 *   · telefonGoster   — GÖSTERİM biçimi. Türkiye'de herkesin alışık olduğu
 *     `0532 111 00 01`. Kanonik olmayan/eski bir değer bozulmadan aynen
 *     döner; gösterim asla veriyi "düzeltmez".
 *   · telefonMaske    — YAZIM biçimi. Kullanıcı yazarken/yapıştırırken
 *     alanın değeri; rakam dışı süzülür, `+90`/`90` öneki düşer, baştaki
 *     sıfır tamamlanır ve gruplanır. Sonuç her zaman gösterim biçimiyle
 *     aynı görünür, böylece "girdiğim ile gördüğüm farklı" olmaz.
 *
 * API tarafı ve iki ön yüz (veli, yönetim) aynı dosyayı kullanır; kayıt bir
 * kurala, giriş başka bir kurala göre çalışırsa hata sessizdir (bkz.
 * apps/api/src/servisler/telefon.ts başlığındaki olay).
 */
/** Örnek yazım — ipucu ve hata mesajlarında tek yerden. */
export const TELEFON_ORNEK = "0532 123 45 67";
/**
 * @returns 10 haneli kanonik numara; girdi bu biçime indirgenemiyorsa `null`.
 *   `null`, "geçersiz numara" demektir ve çağıran tarafta ASLA sessizce
 *   boş dizeye çevrilmemelidir — aksi halde boş telefon tüm velilere eşleşir.
 */
export function telefonNormalize(ham) {
    const rakamlar = ham.replace(/\D/g, "");
    let s = rakamlar;
    if (s.length === 12 && s.startsWith("90"))
        s = s.slice(2);
    if (s.length === 11 && s.startsWith("0"))
        s = s.slice(1);
    return s.length === 10 ? s : null;
}
/** 10 hanelik gövdeyi `0XXX XXX XX XX` olarak gruplar; eksik gövdeyi olduğu kadar. */
function grupla(govde) {
    const p = [
        govde.slice(0, 3),
        govde.slice(3, 6),
        govde.slice(6, 8),
        govde.slice(8, 10),
    ];
    return "0" + p.filter((x) => x.length > 0).join(" ");
}
/**
 * Saklanan değeri kullanıcıya gösterilecek biçime çevirir: `0532 111 00 01`.
 * Boş/null için boş dize; kanonik biçime indirgenemeyen bir değer (eski ham
 * kayıt, yurt dışı numara) DOKUNULMADAN döner.
 */
export function telefonGoster(deger) {
    if (!deger)
        return "";
    const kanonik = telefonNormalize(deger);
    return kanonik ? grupla(kanonik) : deger;
}
/**
 * Girdi alanının `onChange` değeri için maske. Her tuşta çağrılır:
 *   "5"            -> "05"
 *   "+90 532"      -> "0532"
 *   "05321110001"  -> "0532 111 00 01"
 *   "0532 111 00 " -> "0532 111 00"   (silme geriye doğru doğal çalışır)
 * 10 haneden fazlası kesilir; sonuç `telefonNormalize` ile her zaman uyumludur.
 */
export function telefonMaske(ham) {
    let s = ham.replace(/\D/g, "").replace(/^0+/, "");
    if (s.startsWith("90"))
        s = s.slice(2).replace(/^0+/, "");
    s = s.slice(0, 10);
    return s.length === 0 ? "" : grupla(s);
}
//# sourceMappingURL=telefon.js.map